// import external dependencies
import 'jquery';
import 'magnific-popup/dist/jquery.magnific-popup.min';
import 'jQuery-rwdImageMaps/jquery.rwdImageMaps.min';
import 'modaal';

// Import everything from autoload
import "./autoload/_bootstrap.js"

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import singleProducts from './routes/single-product';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  singleProducts,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());


/**
 * Modaal
 */
$(document).ready(function() {

  $('.my-account-tax-modaal').modaal({
    type: 'iframe',
  });

  $('.my-account-modaal').modaal({
    type: 'iframe',
  });

});
